import { render, staticRenderFns } from "./countUp.vue?vue&type=template&id=9f4ee8bc&scoped=true&"
import script from "./countUp.vue?vue&type=script&lang=js&"
export * from "./countUp.vue?vue&type=script&lang=js&"
import style0 from "./countUp.vue?vue&type=style&index=0&id=9f4ee8bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4ee8bc",
  null
  
)

export default component.exports